import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import ImportantInformationPage from './ImportantInformationPage';
import { dataCaptureSelectors, submitEvidenceCall } from '../../store/dataCapture';
import {
  WEB_BUSINESS_TERMS_CONDITIONS,
  WEB_BUSINESS_TARIFF_GUIDE,
  WEB_FSCS_INFORMATION,
  APPLICANT_FLOW,
  WEB_REF_ONLINE_SERVICE_TARIFF,
  WEB_REF_DIGITAL_BANKING_BUSINESS_TERMS
} from '../../utils/constants';
import { selectors as caseSelector } from '../../infrastructure/cases';

class ImportantInformationSection extends Component {
  constructor(props) {
    super(props);

    this.onConfirmationCheckboxChange = this.onConfirmationCheckboxChange.bind(this);
    this.state = { isTermsChecked: false };
  }

  onConfirmationCheckboxChange(value) {
    this.setState({ isTermsChecked: value });
  }

  render() {
    const {
      bankId,
      brandId,
      submitEvidenceCall,
      getBusinessData,
      getSubtype,
      termsConditionsRef,
      tariffGuideRef,
      fscsRef,
      getProductType,
      showLoadingScreen,
      isPrimaryApplicantEditFlow,
      onlineTarrifRef,
      digitalServicesTermsRef
    } = this.props;

    return (
      <ImportantInformationPage
        brandId={brandId}
        bankId={bankId}
        submitEvidenceCall={submitEvidenceCall}
        getBusinessData={getBusinessData}
        getSubtype={getSubtype}
        getProductType={getProductType}
        termsConditionsRef={termsConditionsRef}
        tariffGuideRef={tariffGuideRef}
        fscsRef={fscsRef}
        history={this.props.history}
        showLoadingScreen={showLoadingScreen}
        isPrimaryApplicantEditFlow={isPrimaryApplicantEditFlow}
        onConfirmationCheckboxChange={this.onConfirmationCheckboxChange}
        isTermsChecked={this.state.isTermsChecked}
        onlineTarrifRef={onlineTarrifRef}
        digitalServicesTermsRef={digitalServicesTermsRef}
      />
    );
  }
}

ImportantInformationSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  submitEvidenceCall: PropTypes.func.isRequired
};

const actionCreators = {
  submitEvidenceCall
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  getSubtype: dataCaptureSelectors.getSubtype(state),
  getProductType: dataCaptureSelectors.getProductType(state),
  termsConditionsRef: selectors.getPdfByWebReference(state, WEB_BUSINESS_TERMS_CONDITIONS),
  tariffGuideRef: selectors.getPdfByWebReference(state, WEB_BUSINESS_TARIFF_GUIDE),
  fscsRef: selectors.getPdfByWebReference(state, WEB_FSCS_INFORMATION),
  showLoadingScreen: dataCaptureSelectors.displayLoadingScreen(state),
  isPrimaryApplicantEditFlow: selectors.getSingleEntry(state, APPLICANT_FLOW),
  linkCode: caseSelector.getJointLinkCode(state),
  onlineTarrifRef: selectors.getPdfByWebReference(state, WEB_REF_ONLINE_SERVICE_TARIFF),
  digitalServicesTermsRef: selectors.getPdfByWebReference(
    state,
    WEB_REF_DIGITAL_BANKING_BUSINESS_TERMS
  )
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ImportantInformationSection);
